import { Button } from 'components/ui';
import {
  ErrorImg,
  ErrorScreenWrapper,
  ErrorText,
  ErrorTitle,
} from './error-screen.styled';

export const ErrorScreen = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <ErrorScreenWrapper>
      <ErrorImg />
      <ErrorTitle>Система временно недоступна</ErrorTitle>
      <ErrorText>
        {`Произошла непредвиденная ошибка.
        Наши специалисты уже занимаются её устранением.
        Мы восстановим доступ в ближайшее время.`}
      </ErrorText>
      <Button mode={'neutral'} onClick={handleRefresh}>
        Обновить страницу
      </Button>
    </ErrorScreenWrapper>
  );
};
